"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _knotchWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.box"));

var _knotchWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Error = function Error(_ref) {
  var noData = _ref.noData,
      noUsers = _ref.noUsers,
      noContent = _ref.noContent,
      noArticleContent = _ref.noArticleContent,
      fetchError = _ref.fetchError,
      noImage = _ref.noImage,
      padding = _ref.padding,
      children = _ref.children,
      align = _ref.align;
  return _react["default"].createElement(_knotchWebReactComponents["default"], {
    textAlign: align || 'center',
    p: padding || '48px'
  }, _react["default"].createElement(_knotchWebReactComponents2["default"], {
    color: "#c6c6c6",
    fontWeight: "thin",
    fontSize: "14px"
  }, noData && "Not enough data points.", noArticleContent && "No content available for this page.", noUsers && "No users added.", noImage && "No image available.", noContent && "Please embed the unit using our javascript tag integration to see this metric.", fetchError && "Dang. It seems like we're having trouble loading this!", children));
};

var _default = Error;
exports["default"] = _default;

//# sourceMappingURL=Error.js.map